<template>

    <v-card width="100%" elevation="0">
      <h2 v-if="startupList.length > 0 && !loadingAPI">Associated Startups</h2>
      <v-container fluid class="pa-0 pt-3" v-if="startupList.length > 0 && !loadingAPI">
        <v-data-table
            :headers="headers"
            :items="startupList"
            class="elevation-1"
            :total-items="startupList.length"
            :loading="loading"
        >
          <template v-slot:items="props">
            <td>{{ props.item.name }}</td>
            <td class="text-xs-right">
              <v-tooltip top>
                <template v-slot:activator="{ on }">

                <v-icon
                    small
                    v-on="on"
                    @click="clickdTableRow(props.item)"
                >
                  book
                </v-icon>
                </template>
                <span>View Startup</span>
              </v-tooltip>

            </td>
          </template>

          <template v-slot:no-data>
            <p>No Data found.</p>
          </template>
        </v-data-table>


        <v-dialog
            transition="dialog-bottom-transition"
            max-width="800"
            v-model="startupDetailsDialog" v-if="startupDetailsDialog"
        >
          <v-card>
            <v-card-title class="grey lighten-2">
              <h3>{{clickedStartupObject.Name}}</h3>
            </v-card-title>


            <v-divider></v-divider>
            <v-card>
              <v-list dense>
                <div v-for="[key, value] in Object.entries(clickedStartupObject)">
                  <v-list-tile v-if="value !== '' && !Array.isArray(value)">
                    <v-list-tile-content><b>{{key}}:</b></v-list-tile-content>
                    <v-list-tile-content class="align-end">{{ value }}</v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile v-if="Array.isArray(value)">
                    <v-list-tile-content>{{key}}:</v-list-tile-content>
                    <v-list-tile-content class="align-end">{{ value.join(', ') }}</v-list-tile-content>
                  </v-list-tile>
                </div>
              </v-list>
            </v-card>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  text
                  @click="startupDetailsDialog = false"
              >Close</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>

    </v-card>


</template>

<script>
import Document from "@/components/Radar/Document";
import ApiService from "@/helpers/APIService";
import TimeService from "../../helpers/TimeService";
import UrlsService from "@/helpers/UrlsService";
import APILoaderDecoratorService from "../../helpers/APILoaderDecoratorService";

export default {
        name: "DocumentList",
        components: {Document, ApiService},
        props: {
          trend: {
            type: Object,
            required: true,
          }},
        data() {
            return {
                loadingAPI: false,
                startupCache: {},
                clickedStartupObject: {},
                headers: [
                    { text: 'Startup Name', value: 'name'},
                    { text: 'Actions', value: 'name', width: "5%", align:"right"}],
                loading: true,
                options: {},
                startupDetailsDialog: false,
                startupList: []
            }
        },
        created() {
        },
        mounted() {
          this.getStartupsByTrend();
        },
      computed: {
        },
      watch: {

      },
        methods: {

          formatStartupProperties(startup){
            return new Promise((resolve, reject) => {
              try {
                delete startup["_id"]
                delete startup["token"]
                resolve(startup)
              }catch (e) {}
              resolve(startup)
            })
          },
          clickdTableRow(item){
            this.getStartupById(item._id)
                .then((response) => {
                  let selectedStartup = response.response.startups[0]
                  this.formatStartupProperties(selectedStartup)
                    .then((formattedStartup) => {
                      this.clickedStartupObject = formattedStartup
                      this.startupDetailsDialog = true
                    })
                })
                .catch((error) => {
                  console.log(error)
                })
          },
          getStartupsByTrend() {

            let _this = this;

            let requestUrl = {
              url: UrlsService.startupNamesByTrend,
              timeout: TimeService.secondsToMillis(0),
            };

            let requestBody = {
              "name": this.trend.title,
            };

            ApiService.superadmin(requestUrl,  requestBody, "post")
                .then ( response => {
                  this.startupList = response["result"]
                  this.loading = false
                  console.log(response)
                })
                .catch ( error => { console.log(error) } )
          },

          getStartupById(startupId){

            let _this = this;

            return new Promise((resolve, reject) => {

              let startup={
                _id: startupId
              }
              let requestUrl = {
                url: UrlsService.getStartupById,
                timeout: TimeService.secondsToMillis(0),
              };
              let requestData = {
                interactionData: {
                  startupRequest:{
                    startup:startup
                  }
                },
              };
              let requestObject = {
                type: "normal",
                urlsInfo: requestUrl,
                data: {
                  data: requestData,
                },
              };
              let messages = {
                title: "Get Startup",
                loading: "Waiting for the startup information...",
                error: "Cannot get the startup...",
              };
              let options = {
                loadingType: "fullscreen",
                timeout: TimeService.secondsToMillis(0),
              };
              APILoaderDecoratorService.setLoader(requestObject, messages, options)
                  .then ( response => {
                    resolve(response)
                  })
                  .catch ( error => {
                    reject(error)
                  } )
            });



          }
        }
    }
</script>

<style scoped>
  .capitalize{
    text-transform: capitalize;
  }
</style>
